<template>
  <div id="cloudSeat">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>业务数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>云坐席操作记录</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       @change="loadPark"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fInParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌::">
            <el-input placeholder="请输入车牌"
                      v-model="pageSearch.fPlateCode"
                      class="search">
              <!-- <i slot="prefix"
               class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </el-form-item>
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            type="date"
                            :clearable="false"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:200px"
                            :clearable="false"
                            type="date"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fParkName"
                           width="160"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fChnlName"
                           width="160"
                           label="通道名称">
          </el-table-column>
          <el-table-column label="识别图片" align="center" width="120">
            <template slot-scope="scope">
            <el-image class="image"
                        :src="scope.row.fOutCapPicUrl"
                        :preview-src-list="[scope.row.fOutCapPicUrl]">
                  <template #error>
                    <div class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                </template>
            </el-image>
            </template>
          </el-table-column>
          <el-table-column label="抓拍图片" align="center" width="120">
            <template slot-scope="scope">
            <el-image class="image"
                        :src="scope.row.fCapPicUrl"
                        :preview-src-list="[scope.row.fCapPicUrl]">
                    <template #error>
                    <div class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                </template>
            </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="fPlateCode"
                           width="100"
                           label="车牌号码">
          </el-table-column>
          <el-table-column prop="fCallTime"
                           width="100"
                           label="呼叫时间">
          </el-table-column>
          <el-table-column prop="handTime"
                           width="100"
                           label="完成时间">
          </el-table-column>
          <el-table-column prop="waitTime"
                           label="等待时间">
          </el-table-column>
          <el-table-column prop="status"
                           label="状态">
          </el-table-column>
          <el-table-column prop="fRemark"
                           width="90"
                           label="备注">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="80">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <carInfoView ref="child"
                 reportActiveName="pageData"
                 :type="3"></carInfoView>
    <el-dialog :title="detailTitle"
           v-bind:visible.sync="OpenEditDialog"
           width="60%"
           v-bind:lock-scroll="true"
           center
           custom-class="dlg"
           style="margin-top:10vh"
           v-bind:close-on-click-modal="false">
    <el-form v-bind:model="CloudSeatDetailData"
             ref="form"
             label-width="100px"
             class="demo-ruleForm"
             @@submit.native.prevent>
        <el-row v-bind:gutter="22" class="row-style">
            <el-col v-bind:span="22" class="float-e-margins" style="margin-left:3%;">
                  <el-table border stripe v-bind:data="CloudSeatDetailData.RecordList" max-height="460"  style="margin-top:2vh;margin-left:2vh;margin-bottom:3vh">
                    <el-table-column width="50" label="序号" type="index"></el-table-column>
                    <el-table-column label="场库名称" prop="fParkName" width="150"></el-table-column>
                    <el-table-column label="通道名称" prop="fChnlName" width="150"></el-table-column>
                    <el-table-column label="操作按钮" prop="fOpType" width="150"></el-table-column>
                    <el-table-column label="应付" prop="fReceivable" width="150"></el-table-column>
                    <el-table-column label="实付" prop="fReceipts" width="150"></el-table-column>
                    <el-table-column label="操作内容" prop="func" width="150"></el-table-column>
                    <el-table-column label="事件完成备注" prop="fRemark" width="150"></el-table-column>
                    <el-table-column label="操作时间" prop="fOpLastTime" width="150"></el-table-column>
                    <el-table-column label="操作人员" prop="fUsrName" width="150"></el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </el-form>
</el-dialog>
  </div>
</template>
<script>
import carInfoView from '../../components/carInfoView'
import { report as api } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
import $ from 'jquery'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  components: { carInfoView },
  data () {
    return {
      detailTitle: '',
      is_export: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      pageData: [],
      cust_list: [],
      park_list: [],
      pageCount: 0,
      startTime: '',
      endTime: '',
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fInParkID: '',
        fPlateCode: '',
        fStartTime: '',
        fEndTime: ''
      },
      OpenEditDialog: false,
      CloudSeatDetailData: {
        RecordList: []
      }
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.page_list()
      }, 1000)
    },
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd 00:00:00')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd 23:59:59')
      api.cloudSeatList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.cust_list || []).filter((item) => {
        return item.fCustID === this.pageSearch.fCustID
      })
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd 00:00:00')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd 23:59:59')
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      api.cloudSeatListExport(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_云坐席操作记录.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    loadPark (fCustID) {
      this.pageSearch.fInParkID = ''
      this.park_list = []

      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    changePark () {
      // 加载离场数据列表
      this.page_list()
    },
    init () {
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            if (this.cust_list && this.cust_list.length === 1) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
              this.loadPark(this.pageSearch.fCustID)
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    // 查看详情
    handleInfo (index, row) {
      var parm = {
        fEventID: row.fEventID
      }
      if (row.fPlateCode === '') {
        this.detailTitle = row.fCustName + '-' + row.fParkName
      } else {
        this.detailTitle = row.fCustName + '-' + row.fParkName + '-' + row.fPlateCode
      }
      api.cloudSeatDetailList(parm).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            var obj = data.Data.data
            this.CloudSeatDetailData.RecordList = obj
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
      this.OpenEditDialog = true
    },
    setImgHeight () {
      var formHeight = $('.form_right').height()
      var fplateHeight = $('.fplate_info .el-image').height()
      var carImgHeight = $('.car_img .img').height()
      if (formHeight && fplateHeight > 0) {
        var height = (formHeight - fplateHeight - carImgHeight) / 2
        $('.fplate_info').css({ 'margin-top': height + 'px', 'margin-bottom': height + 'px' })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 210
      obj.tableHeight = clientHeight
      this.setImgHeight()
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 1170000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#cloudSeat .el-dialog {
  min-width: 840px;
}
#cloudSeat .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#cloudSeat .el-dialog__title {
  color: white;
}
#cloudSeat .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#cloudSeat .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
/* 文本框样式 */
#cloudSeat .el-input__inner {
  height: 32px;
  line-height: 32px;
}
#cloudSeat .el-input.is-disabled .el-input__inner,
#cloudSeat .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
#cloudSeat .el-tabs__item {
  height: 32px;
  line-height: 32px;
}
#cloudSeat .el-input__icon {
  line-height: 32px;
}

/* end */
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}

.image {
  width: 120px;
  height: 50px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 80%;
  background: #f5f7fa;
  color: #909399;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/report/cloudSeatData.vue